<div class="galeria">
  <header class="galeria-topo">
    <div class="galeria-info">
      <span class="galeria-autor">{{ atual()?.autor || 'Mídia' }}</span>
      @if (atual()?.data) {
        <span class="galeria-data">{{ atual()?.data | date: 'dd/MM/yyyy - HH:mm' }}</span>
      }
    </div>
    <span class="galeria-contador">{{ indice() + 1 }} / {{ itens().length }}{{ temMaisAnteriores() ? '+' : '' }}</span>
    @if (ehImagem()) {
      <div class="galeria-zoom" @fade>
        <button type="button" class="galeria-btn" aria-label="Diminuir zoom" [disabled]="!ampliada() || atualComErro()" (click)="reduzir()">
          <img src="./assets/icones/redesign/utils/zoom-out.svg" alt="" />
        </button>
        <button type="button" class="galeria-btn" aria-label="Aumentar zoom" [disabled]="escala() >= 4 || atualComErro()" (click)="ampliar()">
          <img src="./assets/icones/redesign/utils/zoom-in.svg" alt="" />
        </button>
      </div>
    }
    <button type="button" class="galeria-btn" aria-label="Abrir no chat" matTooltip="Abrir no chat" (click)="abrirNoChat()">
      <span class="chat-icone-duplo"><img src="./assets/icones/redesign/modulos/chat/components-message/go-to-chat.svg" alt="" class="chat-icone-base" /><img src="./assets/icones/redesign/modulos/chat/components-message/go-to-chat-primary.svg" alt="" class="chat-icone-ativo" /></span>
    </button>
    <button type="button" class="galeria-btn" aria-label="Baixar" matTooltip="Baixar" [disabled]="atualComErro()" (click)="baixar()">
      <img src="./assets/icones/redesign/utils/dowload-white.svg" alt="" />
    </button>
    <button type="button" class="galeria-btn" aria-label="Fechar" (click)="fechar()">
      <img src="./assets/icones/redesign/utils/close.svg" alt="" />
    </button>
  </header>

  <div class="galeria-palco" #palco role="presentation"
      [class.galeria-palco-ampliada]="ampliada()"
      (pointerdown)="aoPressionar($event)"
      (pointermove)="aoMover($event)"
      (pointerup)="aoSoltar($event)"
      (pointercancel)="aoCancelar($event)"
      (wheel)="aoRolar($event)"
      (dblclick)="aoDuploClique($event)"
      (click)="aoClicarPalco()">
    <button type="button" class="galeria-seta galeria-seta-esquerda" aria-label="Anterior"
            [disabled]="indice() === 0 && !temMaisAnteriores()" (pointerdown)="$event.stopPropagation()" (click)="anterior(); $event.stopPropagation()">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <div class="galeria-slide" [class.galeria-slide-transicao]="transicaoSlide()"
         [style.transform]="'translate3d(' + slideX() + ', 0, 0)'" [style.opacity]="opacidadeSlide()">
    @if (atual(); as item) {
      @if (tipoAtual() === 'video') {
        <app-player-video class="galeria-video" [src]="urlSegura(item.url)"
                          (pointerdown)="$event.stopPropagation()" (click)="$event.stopPropagation()"></app-player-video>
      } @else if (tipoAtual() === 'embed') {
        <iframe class="galeria-embed" [src]="urlSegura(item.url)" [title]="nomeArquivo(item)"></iframe>
      } @else if (tipoAtual() === 'documento') {
        <div class="galeria-documento" role="presentation" (click)="$event.stopPropagation()">
          <span class="chat-tipo-arquivo galeria-documento-tipo" [style.border-color]="infoArquivo(item).cor" [matTooltip]="infoArquivo(item).rotulo">
            <img [src]="infoArquivo(item).icone" [alt]="infoArquivo(item).rotulo" />
          </span>
          <span class="galeria-documento-nome">{{ nomeArquivo(item) }}</span>
          <span class="galeria-documento-texto">Este tipo de arquivo não tem pré-visualização no navegador.</span>
          <button type="button" class="galeria-documento-baixar" (click)="baixar()">
            <img src="./assets/icones/redesign/utils/dowload-white.svg" alt="" /> Baixar arquivo
          </button>
        </div>
      } @else if (atualComErro()) {
        <div class="galeria-erro">
          <mat-icon class="galeria-erro-icone">hide_image</mat-icon>
          <span class="galeria-erro-titulo">Imagem não encontrada</span>
          <span class="galeria-erro-texto">O arquivo não está mais disponível ou não pôde ser carregado.</span>
        </div>
      } @else {
        @if (carregandoImagem()) {
          <span class="galeria-carregando" aria-hidden="true"></span>
        }
        <img #imagem class="galeria-imagem" [class.galeria-imagem-oculta]="carregandoImagem()"
            [class.galeria-imagem-interagindo]="interagindo()"
            [style.transform]="transformacao()"
            [src]="item.url" alt="" draggable="false"
            (load)="aoCarregarImagem()" (error)="aoFalharImagem(item.url)"
            (contextmenu)="abrirMenuContexto($event)" />
      }
    }
    </div>

    <button type="button" class="galeria-seta galeria-seta-direita" aria-label="Próxima"
            [disabled]="indice() === itens().length - 1" (pointerdown)="$event.stopPropagation()" (click)="proxima(); $event.stopPropagation()">
      <mat-icon>chevron_right</mat-icon>
    </button>

    @if (ampliada()) {
      <span class="galeria-escala">{{ (escala() * 100).toFixed(0) }}%</span>
    }
  </div>

  @if (menuContexto(); as menu) {
    <div class="galeria-menu-fundo" aria-hidden="true" (click)="fecharMenuContexto()" (contextmenu)="$event.preventDefault(); fecharMenuContexto()"></div>
    <div class="galeria-menu" role="menu" @pop [style.left.px]="menu.x" [style.top.px]="menu.y">
      <button type="button" class="galeria-menu-item" role="menuitem" (click)="abrirNoChat()">
        <img src="./assets/icones/redesign/modulos/chat/components-message/go-to-chat-primary.svg" alt="" /><span>Abrir no chat</span>
      </button>
    </div>
  }

  @if (itens().length > 1 || temMaisAnteriores()) {
    <div class="galeria-miniaturas" #miniaturas>
      @if (temMaisAnteriores()) {
        <button type="button" class="galeria-miniatura galeria-miniatura-mais" [class.galeria-miniatura-carregando]="carregandoAnteriores()"
                aria-label="Carregar mídias mais antigas" matTooltip="Carregar mídias mais antigas" (click)="carregarAnteriores()">
          @if (carregandoAnteriores()) {
            <span class="galeria-miniatura-spinner"></span>
          } @else {
            <mat-icon>more_horiz</mat-icon>
          }
        </button>
      }
      @for (item of itens(); track item.url + $index) {
        <button type="button" class="galeria-miniatura" [class.galeria-miniatura-ativa]="$index === indice()"
                [attr.aria-label]="'Ver item ' + ($index + 1)" (click)="navegarPara($index)">
          @if ((item.tipo ?? 'imagem') !== 'imagem') {
            @if (item.tipo === 'video') {
              <span class="galeria-miniatura-arquivo"><mat-icon>play_circle</mat-icon></span>
            } @else {
              <span class="galeria-miniatura-arquivo galeria-miniatura-documento" [matTooltip]="infoArquivo(item).rotulo">
                <img [src]="infoArquivo(item).icone" [alt]="infoArquivo(item).rotulo" />
              </span>
            }
          } @else if (comErro().has(item.url)) {
            <mat-icon class="galeria-miniatura-erro">hide_image</mat-icon>
          } @else {
            <img [src]="item.url" alt="" loading="lazy" (error)="aoFalharImagem(item.url)" />
          }
        </button>
      }
    </div>
  }
</div>
